import type { FC } from 'react'
import * as Yup from 'yup'
import type { TFunction } from 'i18next'

import { EmailInput, createEmailValidationSchema } from '@dhl/inputs'

export type FormValues = {
  email: string
}

export const initialValues: FormValues = {
  email: '',
}

type FormProps = {
  autoFocusInput?: boolean
  disabled?: boolean
}

export const createValidationSchema = (t: TFunction): Yup.Schema<FormValues> =>
  Yup.object({
    email: createEmailValidationSchema(t),
  })

export const EmailAddressForm: FC<FormProps> = ({ disabled, autoFocusInput }) => (
  <EmailInput
    name="email"
    data-test="email-input"
    disabled={disabled}
    autoFocus={autoFocusInput ?? !disabled}
    fullWidth
    required
  />
)
